import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Row, Col, Button } from 'react-bootstrap';
import { Formik, Form, FormikHelpers } from 'formik';
import { FormGroupControl } from '@components/Base';
import { InferType, object, string } from 'yup';
import { mergeInitialValues } from '@utils/formik';
import i18n from 'i18next';

const GROUP_PROPS = { className: 'mb-3' };

export const formValuesSchema = object().shape({
  search: string().default('').required(i18n.t('validation:required')),
  policyNumber: string().default('').required(i18n.t('validation:required')),
});

export type FormValues = InferType<typeof formValuesSchema>;

const SearchFormHospitalUser = () => {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();

  const initialValues: FormValues = mergeInitialValues(formValuesSchema.getDefault(), Object.fromEntries(searchParams));

  const handleSubmit = (values: FormValues, { setSubmitting }: FormikHelpers<FormValues>) => {
    setSubmitting(false);
    setSearchParams(values);
  };

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={formValuesSchema}
      onSubmit={handleSubmit}
    >
      {({ isSubmitting }) => (
        <Form>
          <Row>
            <Col>
              <FormGroupControl
                required
                name="search"
                label={`Insured search`}
                placeholder="Search by name, member ID"
                groupProps={GROUP_PROPS}
              />
            </Col>
            <Col>
              <FormGroupControl
                required
                name="policyNumber"
                label={t('common:policyNumber')}
                groupProps={GROUP_PROPS}
              />
            </Col>
            <Col>
              <div style={{ marginTop: 30 }}>
                <Button type="submit" variant="primary" disabled={isSubmitting}>
                  {t('common:search')}
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      )}
    </Formik>
  );
};

export { SearchFormHospitalUser };
